export const TWITTER_USERNAME = "@lets_meal";
